import type { UseVoiceOptInState } from './hooks/useVoiceOptIn';

export function VoiceOptInCard({ hook }: { hook: UseVoiceOptInState }) {
    if (!hook.supported) return null;
    if (hook.loading) return null;

    const handleToggle = async () => {
        if (!hook.optIn) {
            await hook.requestPermission();
            await hook.setOptIn(true);
        } else {
            await hook.setOptIn(false);
        }
    };

    return (
        <div className="card">
            <h3 className="font-semibold mb-1">Talk to Moji while driving</h3>
            <p className="muted text-sm mb-3">
                Hands-free voice in the landscape Drive cockpit. Press and hold
                the face or tap the mic button, ask Moji anything, and hear the
                reply. Off by default, turn on below.
            </p>

            <ul className="text-xs text-muted list-disc pl-5 space-y-1 mb-3">
                <li>
                    The mic only records after you press the face or tap the mic
                    button, and stops as soon as Moji catches your words, you go
                    silent for a few seconds, or you press to interrupt or cancel.
                </li>
                <li>
                    Speech-to-text runs through your phone's Android service. On
                    Android 12 and newer this typically stays on your device; on
                    older Android versions the audio is sent to your Android
                    voice service for transcription, the same as your voice keyboard.
                </li>
                <li>
                    Mochi doesn't store the recorded audio. The transcribed text
                    of your question goes to Moji's backend, the same as if you'd
                    typed it.
                </li>
                <li>
                    Voice questions and Moji's replies are saved in your Ask-Moji
                    chat history and contribute to your Pal's memory the same way
                    typed messages do. If Moji can't reach its brain mid-conversation,
                    that exchange is discarded and nothing partial is saved.
                </li>
                <li>
                    Moji's spoken reply is generated locally on your phone. No
                    audio leaves the device for the response.
                </li>
                <li>Music ducks. Volume drops; it is not paused or controlled.</li>
                <li>You can turn this off any time in Settings.</li>
            </ul>

            <label className="flex items-center gap-3 cursor-pointer">
                <button
                    type="button"
                    role="switch"
                    aria-checked={hook.optIn}
                    aria-label="Talk to Moji while driving"
                    onClick={() => { void handleToggle(); }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
                        hook.optIn ? 'bg-brand' : 'bg-line'
                    }`}
                >
                    <span
                        className={`inline-block h-5 w-5 rounded-full bg-surface transition transform ${
                            hook.optIn ? 'translate-x-5' : 'translate-x-0.5'
                        }`}
                    />
                </button>
                <span className="text-sm font-medium">
                    {hook.optIn ? 'On' : 'Off'}
                </span>
            </label>

            {hook.optIn && hook.permission === 'denied' && (
                <div className="mt-3 rounded-lg border border-danger/50 bg-danger/10 p-3 text-sm">
                    <div className="font-medium text-danger mb-1">
                        Mic access disabled
                    </div>
                    <p className="muted text-xs mb-2">
                        You've opted in but Android has blocked microphone
                        access for Mochi. Open Android Settings to enable it.
                    </p>
                    <button
                        type="button"
                        className="btn-secondary text-sm"
                        onClick={() => { void hook.openAppSettings(); }}
                    >
                        Open Android Settings
                    </button>
                </div>
            )}
        </div>
    );
}
